var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"value":_vm.selected},on:{"change":_vm.handleChange}},_vm._l((_vm.options),function(o){return _c('a-select-option',{key:o.label,attrs:{"value":o.id}},[_vm._v(" "+_vm._s(o.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }